import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: 'recuperar-clave',
    title: 'Recuperar Clave',
    data: { title: 'Recuperar Clave' },
    loadComponent: () => import('./pages/recuperar-clave/recuperar-clave.component'),
  },
];
